import React from 'react';
import Icon, { Size } from 'components/general/icon/icon';
import OfficeLocationsTooltip from 'components/office_locations_tooltip/office_locations_tooltip';
import classNames from 'classnames';

const styles = require('./offer_location.module.scss');

interface Props {
  location: string;
  locationIcon: string;
  isGlobalRemote?: boolean;
  officeLocations: any;
  remoteWorkingLabel?: string;
  iconColor: string;
  mini?: boolean;
  timezoneLabel?: string;
}

export default function OfferLocation(props: Props) {
  const {
    locationIcon,
    officeLocations,
    isGlobalRemote,
    remoteWorkingLabel,
    iconColor,
    location,
    mini,
    timezoneLabel,
  } = props;

  const showLocation = !isGlobalRemote && officeLocations.length > 0;
  const onMultipleLocations = officeLocations.length > 1;
  const iconSize = mini ? Size.Medium : Size.MediumLarge;

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Icon
          name={locationIcon}
          size={iconSize}
          className={classNames(styles.icon, styles[iconColor])}
        />
        <div className={classNames(styles.locationLabel, 'location-label')}>
          {location || remoteWorkingLabel}
          {showLocation && remoteWorkingLabel && !mini && <>&nbsp;- {remoteWorkingLabel}</>}
        </div>
        {onMultipleLocations && (
          <OfficeLocationsTooltip
            officeLocations={officeLocations}
            iconColor={iconColor}
            iconSize={iconSize}
          />
        )}
      </div>
      {timezoneLabel && (
        <div className={styles.innerContainer}>
          <div className={styles.timezone}>
            <Icon
              name={'minimalistClock'}
              size={Size.MediumLarge}
              color='silverSandMidDark'
              className={styles.icon}
            />
            <div className={styles.timezoneLabelContainer}>
              <div className={styles.timezoneLabel}>{timezoneLabel}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
